import { Link } from "react-router-dom";
import logo from "@/Assets/white_logo.png";
import linkedIcon from "@/Assets/linkedin.svg";
import instaIcon from "@/Assets/Instagram.svg";
import youtubeIcon from "@/Assets/youtube.svg";
import facebook from "@/Assets/facebook.svg";

const footerLinks = {
  product: [
    // { label: "Features", href: "/#key-features" },
    { label: "Who We Serve", href: "/who-we-serve" },
    { label: "Pricing", href: "/pricing" },
    { label: "Security", href: "/security" },
  ],
  company: [
    { label: "About us", href: "/about" },
    { label: "Contact us", href: "/contact-us" },
  ],
};

const socials = [
  {
    name: "Instagram",
    icon: instaIcon,
    url: "https://www.instagram.com/bridgeformataiq?igsh=ODAydmhoeGUxcTdx",
  },
  {
    name: "LinkedIn",
    icon: linkedIcon,
    url: "https://www.linkedin.com/showcase/bridge-format-aiq",
  },
  {
    name: "YouTube",
    icon: youtubeIcon,
    url: "https://www.youtube.com/@BridgeFormatAIQ",
  },
  {
    name: "Facebook",
    icon: facebook, // Replace with actual Facebook icon if available
    url: "https://www.facebook.com/people/Bridge-Format-AIQ/61578548007524/",
  },
];

export const Footer = () => {
  return (
    <footer className="bg-secondary text-white py-10">
      <div className="container-width">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-6">
          {/* Brand */}
          <div className="pr-16">
            <Link to="/" className="inline-block mb-6">
              <img src={logo} alt="Bridge Format AIQ" className="h-10" />
            </Link>

            <p className="text-sm leading-relaxed mb-6">
              Enterprise Format Intelligence Infrastructure. Transform
              inconsistent documents into standardized, system-ready assets.
            </p>

            <p className="text-xs font-mono uppercase tracking-wider text-white/80">
              The Enterprise Format Intelligence Layer
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-xs font-mono uppercase tracking-wider text-white/80 mb-3">
              Product
            </h4>
            <ul className="space-y-1.5">
              {footerLinks.product.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-mono uppercase tracking-wider text-white/80 mb-3">
              Company
            </h4>
            <ul className="space-y-1.5">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ✅ Socials + Address (Right Side) */}
          <div>
            <h4 className="text-xs font-mono uppercase tracking-wider text-white/80 mb-3">
              Visit
            </h4>
            <ul className="flex items-center gap-4 mb-6">
              {socials.map((social) => (
                <li key={social.name}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:scale-110 transition-transform duration-200"
                  >
                    <img
                      src={social.icon}
                      alt={social.name}
                      className="w-5 h-5"
                    />
                  </a>
                </li>
              ))}
            </ul>
            {/* Address */}
            <div className="text-sm text-white leading-relaxed">
              <p className="font-medium text-white/80 mb-1">Address</p>
              <p>
                3rd Floor, C 62, RWA Colony, Janakpuri, New Delhi
                <br />
                India, 110058
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-white flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/80">
            &copy; {new Date().getFullYear()} Bridge Format AIQ. All rights
            reserved.
          </p>

          <a
            href="https://www.dynamicsmonk.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-white/80 hover:underline"
          >
            Powered by Dynamics Monk
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
